import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-internal-assessments',
  templateUrl: './internal-assessments.component.html',
  styleUrls: ['./internal-assessments.component.scss']
})
export class InternalAssessmentsComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute, private dataService: DataService) { }

  loading: any = false;
  data: any = [];
  batchId: any = 0;
  batch: any = { course: { name: '' }, start_year: '', end_year: '' };

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.batchId = this.route.snapshot.paramMap.get('batchId');
    
    // Use getBatchExams to get the same data structure as examinations
    this.dataService.getBatchExams(this.batchId).subscribe((data: any) => {
      if (data.status == 0) {
        this.data = data.data;
      }
    });

    // Also load batch info for header display
    this.dataService.getBatch(this.batchId).subscribe((data: any) => {
      if (data.status == 0) {
        this.batch = data;
      }
    });
  }

}
